export default { NZ: 'nz', AU: 'au' };
